/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import image from './images/solution.png';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p"
  }, _provideComponents(), props.components), {AboutBody, Primary, ButtonLink} = _components;
  if (!AboutBody) _missingMdxReference("AboutBody", true);
  if (!ButtonLink) _missingMdxReference("ButtonLink", true);
  if (!Primary) _missingMdxReference("Primary", true);
  return React.createElement(AboutBody, {
    image: image
  }, React.createElement(Primary, null, React.createElement(_components.h1, null, "Press'nXPress Customer Feedback Management")), React.createElement(_components.p, null, "Press’nXPress offers a comprehensive customer feedback management platform that enables companies to provide exceptional customer experiences. With the ability to monitor customer satisfaction at every touchpoint along the modern and complex customer journey, Press’nXPress provides valuable insights to help improve the overall customer experience."), React.createElement(_components.p, null, "Utilizing a powerful artificial intelligence (AI) and machine learning (ML) engine, Press’nXPress automates the process of capturing customer feedback and identifies experience gaps in real-time. This allows companies to take action quickly and optimize their customer experiences for improved customer satisfaction."), React.createElement(_components.p, null, "With Press’nXPress, companies can capture customer feedback through various channels, including physical, digital, social, and voice. The cloud-based platform simplifies the process of monitoring customer satisfaction and provides actionable insights to prioritize improvements and drive business success."), React.createElement(ButtonLink, {
    url: "/solutions/",
    text: "Press'nXPress Solution",
    size: "100%",
    bgColor: "#255DDE",
    textColor: "#FFFFFF",
    secondaryColor: "#FFFFFF",
    secondaryTextColor: "#255DDE"
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
